import { render, staticRenderFns } from "./shift-table.vue?vue&type=template&id=5c3e7929&lang=pug"
import script from "./shift-table.vue?vue&type=script&lang=ts"
export * from "./shift-table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports